import React, { Component } from 'react';
import { FormGroup, FormControl, ControlLabel, Col, Checkbox } from 'react-bootstrap';
import Api from './../../../Global/Modules/Api'

class ContactGegevens extends Component {
    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event) {
        const target = event.target
        const isCheckbox = target.type === "checkbox"
        const name = target.name
        isCheckbox ? this.props.onChange(name, target.checked) : this.props.onChange(name, target.value)
    }

    render() {
        const data = this.props.data
        const errors = this.props.errors
       
        return (
            <div>
                {/*
                    TODO: For all adresses: Add postcode + nr check and autofill address, this should not add to addresses outside netherlands.
                */}
                <h5>Contactgegevens</h5>
                <FormGroup controlId="AccountContactBuitenland">
                    <Col componentClass={ControlLabel} sm={4}>
                        Buitenland
                    </Col>
                    <Col sm={6}>
                        <Checkbox name="showCountry" checked={data.country != null} onChange={this.handleChange}>Woonachtig buiten Nederland</Checkbox>
                        {data.country ? 
                            <FormControl componentClass="select" name="country" value={data.country} onChange={this.handleChange}>
                            <option value="1">België</option>
                            <option value="2">Nederlandse Antillen</option>
                            <option value="3">Suriname</option>
                        </FormControl>: null}
                    </Col>
                </FormGroup>
                <FormGroup controlId="AccountVoornaam">
                    <Col componentClass={ControlLabel} sm={4}>
                        Adres + huisnr *
                    </Col>
                    <Col sm={6}>
                        <FormControl value={data.address} type="text" name="address" required onChange={this.handleChange} />
                        {Api.showError(errors, "address")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountPostcode">
                    <Col componentClass={ControlLabel} sm={4}>
                        Postcode *
                </Col>
                    <Col sm={6}>
                        <FormControl value={data.postCode} type="text" name="postCode" required onChange={this.handleChange} />
                        {Api.showError(errors, "postCode")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountPlaats">
                    <Col componentClass={ControlLabel} sm={4}>
                        Plaats *
                </Col>
                    <Col sm={6}>
                        <FormControl value={data.city} type="text" name="city" required onChange={this.handleChange} />
                        {Api.showError(errors, "city")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountTelefoon">
                    <Col componentClass={ControlLabel} sm={4}>
                        Telefoon *
                </Col>
                    <Col sm={6}>
                        <FormControl value={data.phone} type="text" name="phone" required onChange={this.handleChange} /> 
                        {Api.showError(errors, "phone")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountMobiel">
                    <Col componentClass={ControlLabel} sm={4}>
                        Mobiel
                </Col>
                    <Col sm={6}>
                        <FormControl value={data.mobile} type="text" name="mobile" onChange={this.handleChange} />
                        {Api.showError(errors, "mobile")}
                    </Col>
                </FormGroup>

            </div>
        );
    }
}

export default ContactGegevens;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Account/ContactGegevens.js